import * as React from 'react'
import ArianeFeed from '../ArianeFeed/ArianeFeed'
import Loader from '../Loader/Loader'
import StepManager from '../StepManager/StepManager'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { inject } from 'mobx-react'
import { ILayoutStore } from '../../store/LayoutStore'
import { IUserStore } from '../../store/UserStore'
import { tag } from '../../services/ATInternetService'
// import CustomScroll from 'react-custom-scroll'

interface IAppProps extends RouteComponentProps<any> {
  LayoutStore?: ILayoutStore
  UserStore?: IUserStore
}

@inject('LayoutStore', 'UserStore')
class App extends React.Component<IAppProps> {
  public constructor(props: RouteComponentProps) {
    super(props)
    if (this.props.location.search.indexOf('?debug') !== -1) {
      this.props.LayoutStore!.setDebugMode(true)
    }

    this.props.LayoutStore!.reset()

    if (this.props.UserStore!.showResults) {
      // Results have been shown what to do now? i
    }
  }

  public render() {
    tag.sendPage({
      elem: this,
      name: 'Questionnaire',
      chapter1: 'Questionnaire',
    })

    return (
      <div className="Layout-main">
        <ArianeFeed />
        <div className="Layout-scrollable">
          <StepManager />
          <div className="color-wrapper">
            <Loader />
          </div>
        </div>
      </div>
    )
  }
}

// Inject router to props in App Component
export default withRouter(App)



// WEBPACK FOOTER //
// ./src/components/App/App.tsx